import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { useState } from "react";
import Image from "next/image";
import { useMixPanel } from "@/app/context/mixPanelContext";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import { Trans, useTranslation } from "react-i18next";

export function SignInUI({
  switchSignInType,
  setswitchSignInType = () => {},
  islogin = true,
  verificationType = "sign in",
}: {
  switchSignInType?: string;
  setswitchSignInType?: Function;
  islogin?: boolean;
  verificationType?: string;
}) {
  const { config, getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();
  const { trackEvent } = useMixPanel();
  return (
    <div className="login-flex-container-item">
      {/* <div
        className="login-label-top"
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {config?.login?.heading?.showLogo ? (
          <Trans
            i18nKey="registerLogin.welcomeMessageWithComponent"
            components={{
              comp: (
                <Image
                  className="thriwe-Image"
                  src={getImagePath("logo.png") ?? ""}
                  alt=""
                  width="66"
                  height="20"
                  style={{
                    objectFit: "contain",
                    width: "auto",
                  }}
                />
              ),
            }}
          />
        ) : (
          <Trans
            i18nKey="registerLogin.welcomeMessageWithString"
            values={{
              field: config?.login?.heading?.subText,
            }}
            components={{ span: <span className="sub_text" /> }}
          />
        )}
      </div> */}
      {verificationType == "sign in" && (
        <div
          className="login-label-bottom"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            textWrap: "nowrap",
          }}
        >
          {verificationType == "sign in"
            ? islogin
              ? t("registerLogin.loginHeading", t("common.signIn")) ||
                t("common.signIn")
              : t("registerLogin.signUpHeading", t("common.signUp")) ||
                t("common.signUp")
            : t("registerLogin.verifyOTP")}
          {verificationType == "sign in"
            ? switchSignInType &&
              Object.keys(config?.login?.fields ?? {})?.length > 1 && (
                <div
                  className="switch-email-mobile-container"
                  role="button"
                  onClick={() => {
                    console.log("switch", switchSignInType);
                    if (switchSignInType == "email") {
                      setswitchSignInType("mobile");
                      trackEvent(EventLabels.CTA_Mobile_Key, {
                        screen: "Login",
                      });
                    } else if (switchSignInType == "mobile") {
                      setswitchSignInType("email");
                      trackEvent(EventLabels.CTA_Email_Key, {
                        screen: "Login",
                      });
                    }
                  }}
                >
                  <Image
                    className="switch-email-mobile-image"
                    src={
                      switchSignInType == "mobile"
                        ? getImagePath("email.png")
                        : getImagePath("login-mobile.png") ?? ""
                    }
                    alt=""
                    width="20"
                    height="20"
                    style={{
                      objectFit: "contain",
                    }}
                  />

                  <div className="signin-switch">
                    {t(
                      islogin
                        ? "registerLogin.sign_in_with"
                        : "registerLogin.sign_up_with",
                      {
                        method:
                          switchSignInType === "mobile"
                            ? t("common.email_address")
                            : t("common.phone_number"),
                      }
                    )}
                  </div>
                </div>
              )
            : null}
        </div>
      )}
    </div>
  );
}
